import Head from 'next/head'
import { useContext } from 'react';
import styles from "../../../styles/Pages/Packages.module.scss"
import Topbanner from '../../../components/Reusable/Banner/Topbanner'
import { CartContext } from '../../../context/CartContext';
import dynamic from 'next/dynamic'

const CartItems = dynamic(() => import('../../../components/Reusable/Cart/CartItems'), { ssr: false });

export default function Cart() {
    const { cart, removeFromCart, handleIncrementQuantity, handleDecrementQuantity } = useContext(CartContext);
    return (
        <>
            <Head>
                <title>Cart Adventre Resorts</title>
                <link rel="icon" href="/favicon.png" />
            </Head>
            {/* <Topbanner title={"Cart"} bgImage={"/images/checkout-banner.png"} target="#firstsec" /> */}

            <section className='tickets_page_banner'
                style={{ backgroundImage: 'url(/images/banners/cart-banner.jpg)' }}
                target="#firstsec"
            >
                <div className='tickets_page_banner_text'>
                <div className='container common_title'>
                    <h1>Cart</h1>
                </div>
                </div>
            </section>
            <CartItems cart={cart}
                removeFromCart={removeFromCart}
                handleIncrementQuantity={handleIncrementQuantity}
                handleDecrementQuantity={handleDecrementQuantity}
            />
        </>
    )
}
